<template>
  <div>
    <h3 class="mt-n4 mb-4" style="color: red" v-if="failText">
      {{ $t(failText) }}
    </h3>
    <h3 class="mt-n4 mb-4" style="color: green" v-if="successText">
      {{ successText }}
    </h3>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {}
})
export default class LoginComponentMessage extends Vue {
  @Prop({ required: true })
  failText!: string;

  @Prop({ required: true })
  successText!: string;
}
</script>
